import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class SuggestionService {
  constructor(database, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  find(attrs, callback, path, { orgId }) {
    let suggestions = this._getPhraseSuggestions(orgId);
    callback(null, { status: 200, statusText: statusText(200), response: { suggestions } });
  }

  _getPhraseSuggestions(orgId, customerId) {
    let database = this.getDatabase(orgId);

    return database.phraseSuggestions || [{ id: '1', text: 'Hi, how can I help you?', score: 100 }];
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/phrase-suggestions': {
          GET: this.find,
        },
      },
      this
    );
  }
}
